import { Checkbox, Stack } from "@mantine/core";
import React from "react";
import { useActions, useAppState } from "src/state";
import { User_Type_Enum } from "src/state/gql/_types";
import { useCalendar } from "./CalendarContext";

export const CalendarTalentFilter: React.FC<{}> = () => {

    const { itemsList, loading } = useAppState(state => state.users)
    const getAllItems = useActions().users.getAllItems
    const { talentFilter, setTalentFilter } = useCalendar()

    React.useEffect(() => {
        getAllItems({
            where: {
                type: { _eq: User_Type_Enum.Talent }
            }
        })
    }, [])

    if (loading) return <span>Loading...</span>

    const allSelected = talentFilter.length === 0
    const someSelected = talentFilter.length > 0 && talentFilter.length < itemsList.length

    const handleAllTalentChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (allSelected) {
            event.preventDefault()
        } else {
            setTalentFilter([])
        }
    }

    return (
        <Stack gap="xs">

            <Checkbox
                label="All Talent"
                checked={allSelected}
                indeterminate={someSelected}
                onChange={handleAllTalentChange}
            />

            <Stack gap="xs">
                {itemsList.map((user) => (
                    <Checkbox
                        key={user.id}
                        value={user.id}
                        label={user.dj_display}
                        color={user.color||'dark'}
                        onChange={(event) => {
                            const checked = event.currentTarget.checked
                            if (checked) {
                                setTalentFilter(talentFilter.filter(id => id !== user.id))
                            } else {
                                if (talentFilter.length !== itemsList.length - 1) {
                                    setTalentFilter([...talentFilter, user.id])
                                }
                            }
                        }}
                        checked={allSelected ? true : !talentFilter.includes(user.id)}
                    />
                ))}
            </Stack>

        </Stack>
    )

}